
import React      from 'react';
import CSSModules from 'react-css-modules';

import classNames   from 'classnames/bind';
import stylingUtils from '../../services/stylingUtilities';

import PageLink from '../PageLink';

import style from './style.scss';

class ButtonLink extends React.Component {

    _getButtonStyleName() {

        return this.props.disabled === true ? 'link--disabled' : 'link';
    }

    render() {

        return (
            <PageLink styleName={ this._getButtonStyleName() } { ...this.props }>

                { this.props.children }

            </PageLink>
        );
    }
}

export default CSSModules(ButtonLink, style);


// WEBPACK FOOTER //
// ./components/ButtonLink/index.js